// Dtos
import { ManufacturerDto } from "../dtos/Manufacturer.dto";

// Domain
import { Manufacturer } from "../../app/domain/Manufacturer";
// enums
import { ResponseStatusType } from "../../../enums/api";

export type TrucksManufacturersResponseDataType = {
  truck_manufacturers: ManufacturerDto[];
  statusType: ResponseStatusType;
};

export class TrucksManufacturersResponse {
  manufacturers: Manufacturer[];
  statusType: ResponseStatusType;
  constructor(responseData: TrucksManufacturersResponseDataType) {
    this.manufacturers = responseData.truck_manufacturers.map(
      (manufacturer) => new Manufacturer(manufacturer)
    );
    this.statusType = ResponseStatusType.OK;
  }
}
